/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

export default {
  "glass": {
    "unicode": "\uf000"
  },
  "music": {
    "unicode": "\uf001"
  },
  "search": {
    "unicode": "\uf002"
  },
  "envelope-o": {
    "unicode": "\uf003"
  },
  "heart": {
    "unicode": "\uf004"
  },
  "star": {
    "unicode": "\uf005"
  },
  "star-o": {
    "unicode": "\uf006"
  },
  "user": {
    "unicode": "\uf007"
  },
  "film": {
    "unicode": "\uf008"
  },
  "th-large": {
    "unicode": "\uf009"
  },
  "th": {
    "unicode": "\uf00a"
  },
  "th-list": {
    "unicode": "\uf00b"
  },
  "check": {
    "unicode": "\uf00c"
  },
  "times": {
    "unicode": "\uf00d"
  },
  "search-plus": {
    "unicode": "\uf00e"
  },
  "search-minus": {
    "unicode": "\uf010"
  },
  "power-off": {
    "unicode": "\uf011"
  },
  "signal": {
    "unicode": "\uf012"
  },
  "cog": {
    "unicode": "\uf013"
  },
  "trash-o": {
    "unicode": "\uf014"
  },
  "home": {
    "unicode": "\uf015"
  },
  "file-o": {
    "unicode": "\uf016"
  },
  "clock-o": {
    "unicode": "\uf017"
  },
  "road": {
    "unicode": "\uf018"
  },
  "download": {
    "unicode": "\uf019"
  },
  "arrow-circle-o-down": {
    "unicode": "\uf01a"
  },
  "arrow-circle-o-up": {
    "unicode": "\uf01b"
  },
  "inbox": {
    "unicode": "\uf01c"
  },
  "play-circle-o": {
    "unicode": "\uf01d"
  },
  "repeat": {
    "unicode": "\uf01e"
  },
  "refresh": {
    "unicode": "\uf021"
  },
  "list-alt": {
    "unicode": "\uf022"
  },
  "lock": {
    "unicode": "\uf023"
  },
  "flag": {
    "unicode": "\uf024"
  },
  "headphones": {
    "unicode": "\uf025"
  },
  "volume-off": {
    "unicode": "\uf026"
  },
  "volume-down": {
    "unicode": "\uf027"
  },
  "volume-up": {
    "unicode": "\uf028"
  },
  "qrcode": {
    "unicode": "\uf029"
  },
  "barcode": {
    "unicode": "\uf02a"
  },
  "tag": {
    "unicode": "\uf02b"
  },
  "tags": {
    "unicode": "\uf02c"
  },
  "book": {
    "unicode": "\uf02d"
  },
  "bookmark": {
    "unicode": "\uf02e"
  },
  "print": {
    "unicode": "\uf02f"
  },
  "camera": {
    "unicode": "\uf030"
  },
  "font": {
    "unicode": "\uf031"
  },
  "bold": {
    "unicode": "\uf032"
  },
  "italic": {
    "unicode": "\uf033"
  },
  "text-height": {
    "unicode": "\uf034"
  },
  "text-width": {
    "unicode": "\uf035"
  },
  "align-left": {
    "unicode": "\uf036"
  },
  "align-center": {
    "unicode": "\uf037"
  },
  "align-right": {
    "unicode": "\uf038"
  },
  "align-justify": {
    "unicode": "\uf039"
  },
  "list": {
    "unicode": "\uf03a"
  },
  "outdent": {
    "unicode": "\uf03b"
  },
  "indent": {
    "unicode": "\uf03c"
  },
  "video-camera": {
    "unicode": "\uf03d"
  },
  "picture-o": {
    "unicode": "\uf03e"
  },
  "pencil": {
    "unicode": "\uf040"
  },
  "map-marker": {
    "unicode": "\uf041"
  },
  "adjust": {
    "unicode": "\uf042"
  },
  "tint": {
    "unicode": "\uf043"
  },
  "pencil-square-o": {
    "unicode": "\uf044"
  },
  "share-square-o": {
    "unicode": "\uf045"
  },
  "check-square-o": {
    "unicode": "\uf046"
  },
  "arrows": {
    "unicode": "\uf047"
  },
  "step-backward": {
    "unicode": "\uf048"
  },
  "fast-backward": {
    "unicode": "\uf049"
  },
  "backward": {
    "unicode": "\uf04a"
  },
  "play": {
    "unicode": "\uf04b"
  },
  "pause": {
    "unicode": "\uf04c"
  },
  "stop": {
    "unicode": "\uf04d"
  },
  "forward": {
    "unicode": "\uf04e"
  },
  "fast-forward": {
    "unicode": "\uf050"
  },
  "step-forward": {
    "unicode": "\uf051"
  },
  "eject": {
    "unicode": "\uf052"
  },
  "chevron-left": {
    "unicode": "\uf053"
  },
  "chevron-right": {
    "unicode": "\uf054"
  },
  "plus-circle": {
    "unicode": "\uf055"
  },
  "minus-circle": {
    "unicode": "\uf056"
  },
  "times-circle": {
    "unicode": "\uf057"
  },
  "check-circle": {
    "unicode": "\uf058"
  },
  "question-circle": {
    "unicode": "\uf059"
  },
  "info-circle": {
    "unicode": "\uf05a"
  },
  "crosshairs": {
    "unicode": "\uf05b"
  },
  "times-circle-o": {
    "unicode": "\uf05c"
  },
  "check-circle-o": {
    "unicode": "\uf05d"
  },
  "ban": {
    "unicode": "\uf05e"
  },
  "arrow-left": {
    "unicode": "\uf060"
  },
  "arrow-right": {
    "unicode": "\uf061"
  },
  "arrow-up": {
    "unicode": "\uf062"
  },
  "arrow-down": {
    "unicode": "\uf063"
  },
  "share": {
    "unicode": "\uf064"
  },
  "expand": {
    "unicode": "\uf065"
  },
  "compress": {
    "unicode": "\uf066"
  },
  "plus": {
    "unicode": "\uf067"
  },
  "minus": {
    "unicode": "\uf068"
  },
  "asterisk": {
    "unicode": "\uf069"
  },
  "exclamation-circle": {
    "unicode": "\uf06a"
  },
  "gift": {
    "unicode": "\uf06b"
  },
  "leaf": {
    "unicode": "\uf06c"
  },
  "fire": {
    "unicode": "\uf06d"
  },
  "eye": {
    "unicode": "\uf06e"
  },
  "eye-slash": {
    "unicode": "\uf070"
  },
  "exclamation-triangle": {
    "unicode": "\uf071"
  },
  "plane": {
    "unicode": "\uf072"
  },
  "calendar": {
    "unicode": "\uf073"
  },
  "random": {
    "unicode": "\uf074"
  },
  "comment": {
    "unicode": "\uf075"
  },
  "magnet": {
    "unicode": "\uf076"
  },
  "chevron-up": {
    "unicode": "\uf077"
  },
  "chevron-down": {
    "unicode": "\uf078"
  },
  "retweet": {
    "unicode": "\uf079"
  },
  "shopping-cart": {
    "unicode": "\uf07a"
  },
  "folder": {
    "unicode": "\uf07b"
  },
  "folder-open": {
    "unicode": "\uf07c"
  },
  "arrows-v": {
    "unicode": "\uf07d"
  },
  "arrows-h": {
    "unicode": "\uf07e"
  },
  "bar-chart": {
    "unicode": "\uf080"
  },
  "twitter-square": {
    "unicode": "\uf081"
  },
  "facebook-square": {
    "unicode": "\uf082"
  },
  "camera-retro": {
    "unicode": "\uf083"
  },
  "key": {
    "unicode": "\uf084"
  },
  "cogs": {
    "unicode": "\uf085"
  },
  "comments": {
    "unicode": "\uf086"
  },
  "thumbs-o-up": {
    "unicode": "\uf087"
  },
  "thumbs-o-down": {
    "unicode": "\uf088"
  },
  "star-half": {
    "unicode": "\uf089"
  },
  "heart-o": {
    "unicode": "\uf08a"
  },
  "sign-out": {
    "unicode": "\uf08b"
  },
  "linkedin-square": {
    "unicode": "\uf08c"
  },
  "thumb-tack": {
    "unicode": "\uf08d"
  },
  "external-link": {
    "unicode": "\uf08e"
  },
  "sign-in": {
    "unicode": "\uf090"
  },
  "trophy": {
    "unicode": "\uf091"
  },
  "github-square": {
    "unicode": "\uf092"
  },
  "upload": {
    "unicode": "\uf093"
  },
  "lemon-o": {
    "unicode": "\uf094"
  },
  "phone": {
    "unicode": "\uf095"
  },
  "square-o": {
    "unicode": "\uf096"
  },
  "bookmark-o": {
    "unicode": "\uf097"
  },
  "phone-square": {
    "unicode": "\uf098"
  },
  "twitter": {
    "unicode": "\uf099"
  },
  "facebook": {
    "unicode": "\uf09a"
  },
  "github": {
    "unicode": "\uf09b"
  },
  "unlock": {
    "unicode": "\uf09c"
  },
  "credit-card": {
    "unicode": "\uf09d"
  },
  "rss": {
    "unicode": "\uf09e"
  },
  "hdd-o": {
    "unicode": "\uf0a0"
  },
  "bullhorn": {
    "unicode": "\uf0a1"
  },
  "bell": {
    "unicode": "\uf0f3"
  },
  "certificate": {
    "unicode": "\uf0a3"
  },
  "hand-o-right": {
    "unicode": "\uf0a4"
  },
  "hand-o-left": {
    "unicode": "\uf0a5"
  },
  "hand-o-up": {
    "unicode": "\uf0a6"
  },
  "hand-o-down": {
    "unicode": "\uf0a7"
  },
  "arrow-circle-left": {
    "unicode": "\uf0a8"
  },
  "arrow-circle-right": {
    "unicode": "\uf0a9"
  },
  "arrow-circle-up": {
    "unicode": "\uf0aa"
  },
  "arrow-circle-down": {
    "unicode": "\uf0ab"
  },
  "globe": {
    "unicode": "\uf0ac"
  },
  "wrench": {
    "unicode": "\uf0ad"
  },
  "tasks": {
    "unicode": "\uf0ae"
  },
  "filter": {
    "unicode": "\uf0b0"
  },
  "briefcase": {
    "unicode": "\uf0b1"
  },
  "arrows-alt": {
    "unicode": "\uf0b2"
  },
  "users": {
    "unicode": "\uf0c0"
  },
  "link": {
    "unicode": "\uf0c1"
  },
  "cloud": {
    "unicode": "\uf0c2"
  },
  "flask": {
    "unicode": "\uf0c3"
  },
  "scissors": {
    "unicode": "\uf0c4"
  },
  "files-o": {
    "unicode": "\uf0c5"
  },
  "paperclip": {
    "unicode": "\uf0c6"
  },
  "floppy-o": {
    "unicode": "\uf0c7"
  },
  "square": {
    "unicode": "\uf0c8"
  },
  "bars": {
    "unicode": "\uf0c9"
  },
  "list-ul": {
    "unicode": "\uf0ca"
  },
  "list-ol": {
    "unicode": "\uf0cb"
  },
  "strikethrough": {
    "unicode": "\uf0cc"
  },
  "underline": {
    "unicode": "\uf0cd"
  },
  "table": {
    "unicode": "\uf0ce"
  },
  "magic": {
    "unicode": "\uf0d0"
  },
  "truck": {
    "unicode": "\uf0d1"
  },
  "pinterest": {
    "unicode": "\uf0d2"
  },
  "pinterest-square": {
    "unicode": "\uf0d3"
  },
  "google-plus-square": {
    "unicode": "\uf0d4"
  },
  "google-plus": {
    "unicode": "\uf0d5"
  },
  "money": {
    "unicode": "\uf0d6"
  },
  "caret-down": {
    "unicode": "\uf0d7"
  },
  "caret-up": {
    "unicode": "\uf0d8"
  },
  "caret-left": {
    "unicode": "\uf0d9"
  },
  "caret-right": {
    "unicode": "\uf0da"
  },
  "columns": {
    "unicode": "\uf0db"
  },
  "sort": {
    "unicode": "\uf0dc"
  },
  "sort-desc": {
    "unicode": "\uf0dd"
  },
  "sort-asc": {
    "unicode": "\uf0de"
  },
  "envelope": {
    "unicode": "\uf0e0"
  },
  "linkedin": {
    "unicode": "\uf0e1"
  },
  "undo": {
    "unicode": "\uf0e2"
  },
  "gavel": {
    "unicode": "\uf0e3"
  },
  "tachometer": {
    "unicode": "\uf0e4"
  },
  "comment-o": {
    "unicode": "\uf0e5"
  },
  "comments-o": {
    "unicode": "\uf0e6"
  },
  "bolt": {
    "unicode": "\uf0e7"
  },
  "sitemap": {
    "unicode": "\uf0e8"
  },
  "umbrella": {
    "unicode": "\uf0e9"
  },
  "clipboard": {
    "unicode": "\uf0ea"
  },
  "lightbulb-o": {
    "unicode": "\uf0eb"
  },
  "exchange": {
    "unicode": "\uf0ec"
  },
  "cloud-download": {
    "unicode": "\uf0ed"
  },
  "cloud-upload": {
    "unicode": "\uf0ee"
  },
  "user-md": {
    "unicode": "\uf0f0"
  },
  "stethoscope": {
    "unicode": "\uf0f1"
  },
  "suitcase": {
    "unicode": "\uf0f2"
  },
  "bell-o": {
    "unicode": "\uf0a2"
  },
  "coffee": {
    "unicode": "\uf0f4"
  },
  "cutlery": {
    "unicode": "\uf0f5"
  },
  "file-text-o": {
    "unicode": "\uf0f6"
  },
  "building-o": {
    "unicode": "\uf0f7"
  },
  "hospital-o": {
    "unicode": "\uf0f8"
  },
  "ambulance": {
    "unicode": "\uf0f9"
  },
  "medkit": {
    "unicode": "\uf0fa"
  },
  "fighter-jet": {
    "unicode": "\uf0fb"
  },
  "beer": {
    "unicode": "\uf0fc"
  },
  "h-square": {
    "unicode": "\uf0fd"
  },
  "plus-square": {
    "unicode": "\uf0fe"
  },
  "angle-double-left": {
    "unicode": "\uf100"
  },
  "angle-double-right": {
    "unicode": "\uf101"
  },
  "angle-double-up": {
    "unicode": "\uf102"
  },
  "angle-double-down": {
    "unicode": "\uf103"
  },
  "angle-left": {
    "unicode": "\uf104"
  },
  "angle-right": {
    "unicode": "\uf105"
  },
  "angle-up": {
    "unicode": "\uf106"
  },
  "angle-down": {
    "unicode": "\uf107"
  },
  "desktop": {
    "unicode": "\uf108"
  },
  "laptop": {
    "unicode": "\uf109"
  },
  "tablet": {
    "unicode": "\uf10a"
  },
  "mobile": {
    "unicode": "\uf10b"
  },
  "circle-o": {
    "unicode": "\uf10c"
  },
  "quote-left": {
    "unicode": "\uf10d"
  },
  "quote-right": {
    "unicode": "\uf10e"
  },
  "spinner": {
    "unicode": "\uf110"
  },
  "circle": {
    "unicode": "\uf111"
  },
  "reply": {
    "unicode": "\uf112"
  },
  "github-alt": {
    "unicode": "\uf113"
  },
  "folder-o": {
    "unicode": "\uf114"
  },
  "folder-open-o": {
    "unicode": "\uf115"
  },
  "smile-o": {
    "unicode": "\uf118"
  },
  "frown-o": {
    "unicode": "\uf119"
  },
  "meh-o": {
    "unicode": "\uf11a"
  },
  "gamepad": {
    "unicode": "\uf11b"
  },
  "keyboard-o": {
    "unicode": "\uf11c"
  },
  "flag-o": {
    "unicode": "\uf11d"
  },
  "flag-checkered": {
    "unicode": "\uf11e"
  },
  "terminal": {
    "unicode": "\uf120"
  },
  "code": {
    "unicode": "\uf121"
  },
  "reply-all": {
    "unicode": "\uf122"
  },
  "star-half-o": {
    "unicode": "\uf123"
  },
  "location-arrow": {
    "unicode": "\uf124"
  },
  "crop": {
    "unicode": "\uf125"
  },
  "code-fork": {
    "unicode": "\uf126"
  },
  "chain-broken": {
    "unicode": "\uf127"
  },
  "question": {
    "unicode": "\uf128"
  },
  "info": {
    "unicode": "\uf129"
  },
  "exclamation": {
    "unicode": "\uf12a"
  },
  "superscript": {
    "unicode": "\uf12b"
  },
  "subscript": {
    "unicode": "\uf12c"
  },
  "eraser": {
    "unicode": "\uf12d"
  },
  "puzzle-piece": {
    "unicode": "\uf12e"
  },
  "microphone": {
    "unicode": "\uf130"
  },
  "microphone-slash": {
    "unicode": "\uf131"
  },
  "shield": {
    "unicode": "\uf132"
  },
  "calendar-o": {
    "unicode": "\uf133"
  },
  "fire-extinguisher": {
    "unicode": "\uf134"
  },
  "rocket": {
    "unicode": "\uf135"
  },
  "maxcdn": {
    "unicode": "\uf136"
  },
  "chevron-circle-left": {
    "unicode": "\uf137"
  },
  "chevron-circle-right": {
    "unicode": "\uf138"
  },
  "chevron-circle-up": {
    "unicode": "\uf139"
  },
  "chevron-circle-down": {
    "unicode": "\uf13a"
  },
  "html5": {
    "unicode": "\uf13b"
  },
  "css3": {
    "unicode": "\uf13c"
  },
  "anchor": {
    "unicode": "\uf13d"
  },
  "unlock-alt": {
    "unicode": "\uf13e"
  },
  "bullseye": {
    "unicode": "\uf140"
  },
  "ellipsis-h": {
    "unicode": "\uf141"
  },
  "ellipsis-v": {
    "unicode": "\uf142"
  },
  "rss-square": {
    "unicode": "\uf143"
  },
  "play-circle": {
    "unicode": "\uf144"
  },
  "ticket": {
    "unicode": "\uf145"
  },
  "minus-square": {
    "unicode": "\uf146"
  },
  "minus-square-o": {
    "unicode": "\uf147"
  },
  "level-up": {
    "unicode": "\uf148"
  },
  "level-down": {
    "unicode": "\uf149"
  },
  "check-square": {
    "unicode": "\uf14a"
  },
  "pencil-square": {
    "unicode": "\uf14b"
  },
  "external-link-square": {
    "unicode": "\uf14c"
  },
  "share-square": {
    "unicode": "\uf14d"
  },
  "compass": {
    "unicode": "\uf14e"
  },
  "caret-square-o-down": {
    "unicode": "\uf150"
  },
  "caret-square-o-up": {
    "unicode": "\uf151"
  },
  "caret-square-o-right": {
    "unicode": "\uf152"
  },
  "eur": {
    "unicode": "\uf153"
  },
  "gbp": {
    "unicode": "\uf154"
  },
  "usd": {
    "unicode": "\uf155"
  },
  "inr": {
    "unicode": "\uf156"
  },
  "jpy": {
    "unicode": "\uf157"
  },
  "rub": {
    "unicode": "\uf158"
  },
  "krw": {
    "unicode": "\uf159"
  },
  "btc": {
    "unicode": "\uf15a"
  },
  "file": {
    "unicode": "\uf15b"
  },
  "file-text": {
    "unicode": "\uf15c"
  },
  "sort-alpha-asc": {
    "unicode": "\uf15d"
  },
  "sort-alpha-desc": {
    "unicode": "\uf15e"
  },
  "sort-amount-asc": {
    "unicode": "\uf160"
  },
  "sort-amount-desc": {
    "unicode": "\uf161"
  },
  "sort-numeric-asc": {
    "unicode": "\uf162"
  },
  "sort-numeric-desc": {
    "unicode": "\uf163"
  },
  "thumbs-up": {
    "unicode": "\uf164"
  },
  "thumbs-down": {
    "unicode": "\uf165"
  },
  "youtube-square": {
    "unicode": "\uf166"
  },
  "youtube": {
    "unicode": "\uf167"
  },
  "xing": {
    "unicode": "\uf168"
  },
  "xing-square": {
    "unicode": "\uf169"
  },
  "youtube-play": {
    "unicode": "\uf16a"
  },
  "dropbox": {
    "unicode": "\uf16b"
  },
  "stack-overflow": {
    "unicode": "\uf16c"
  },
  "instagram": {
    "unicode": "\uf16d"
  },
  "flickr": {
    "unicode": "\uf16e"
  },
  "adn": {
    "unicode": "\uf170"
  },
  "bitbucket": {
    "unicode": "\uf171"
  },
  "bitbucket-square": {
    "unicode": "\uf172"
  },
  "tumblr": {
    "unicode": "\uf173"
  },
  "tumblr-square": {
    "unicode": "\uf174"
  },
  "long-arrow-down": {
    "unicode": "\uf175"
  },
  "long-arrow-up": {
    "unicode": "\uf176"
  },
  "long-arrow-left": {
    "unicode": "\uf177"
  },
  "long-arrow-right": {
    "unicode": "\uf178"
  },
  "apple": {
    "unicode": "\uf179"
  },
  "windows": {
    "unicode": "\uf17a"
  },
  "android": {
    "unicode": "\uf17b"
  },
  "linux": {
    "unicode": "\uf17c"
  },
  "dribbble": {
    "unicode": "\uf17d"
  },
  "skype": {
    "unicode": "\uf17e"
  },
  "foursquare": {
    "unicode": "\uf180"
  },
  "trello": {
    "unicode": "\uf181"
  },
  "woman": {
    "unicode": "\uf182"
  },
  "man": {
    "unicode": "\uf183"
  },
  "gratipay": {
    "unicode": "\uf184"
  },
  "sun-o": {
    "unicode": "\uf185"
  },
  "moon-o": {
    "unicode": "\uf186"
  },
  "archive": {
    "unicode": "\uf187"
  },
  "bug": {
    "unicode": "\uf188"
  },
  "vk": {
    "unicode": "\uf189"
  },
  "weibo": {
    "unicode": "\uf18a"
  },
  "renren": {
    "unicode": "\uf18b"
  },
  "pagelines": {
    "unicode": "\uf18c"
  },
  "stack-exchange": {
    "unicode": "\uf18d"
  },
  "arrow-circle-o-right": {
    "unicode": "\uf18e"
  },
  "arrow-circle-o-left": {
    "unicode": "\uf190"
  },
  "caret-square-o-left": {
    "unicode": "\uf191"
  },
  "dot-circle-o": {
    "unicode": "\uf192"
  },
  "wheelchair": {
    "unicode": "\uf193"
  },
  "vimeo-square": {
    "unicode": "\uf194"
  },
  "try": {
    "unicode": "\uf195"
  },
  "plus-square-o": {
    "unicode": "\uf196"
  },
  "space-shuttle": {
    "unicode": "\uf197"
  },
  "slack": {
    "unicode": "\uf198"
  },
  "envelope-square": {
    "unicode": "\uf199"
  },
  "wordpress": {
    "unicode": "\uf19a"
  },
  "openid": {
    "unicode": "\uf19b"
  },
  "university": {
    "unicode": "\uf19c"
  },
  "graduation-cap": {
    "unicode": "\uf19d"
  },
  "yahoo": {
    "unicode": "\uf19e"
  },
  "google": {
    "unicode": "\uf1a0"
  },
  "reddit": {
    "unicode": "\uf1a1"
  },
  "reddit-square": {
    "unicode": "\uf1a2"
  },
  "stumbleupon-circle": {
    "unicode": "\uf1a3"
  },
  "stumbleupon": {
    "unicode": "\uf1a4"
  },
  "delicious": {
    "unicode": "\uf1a5"
  },
  "digg": {
    "unicode": "\uf1a6"
  },
  "pied-piper": {
    "unicode": "\uf1a7"
  },
  "pied-piper-alt": {
    "unicode": "\uf1a8"
  },
  "drupal": {
    "unicode": "\uf1a9"
  },
  "joomla": {
    "unicode": "\uf1aa"
  },
  "language": {
    "unicode": "\uf1ab"
  },
  "fax": {
    "unicode": "\uf1ac"
  },
  "building": {
    "unicode": "\uf1ad"
  },
  "child": {
    "unicode": "\uf1ae"
  },
  "paw": {
    "unicode": "\uf1b0"
  },
  "spoon": {
    "unicode": "\uf1b1"
  },
  "cube": {
    "unicode": "\uf1b2"
  },
  "cubes": {
    "unicode": "\uf1b3"
  },
  "behance": {
    "unicode": "\uf1b4"
  },
  "behance-square": {
    "unicode": "\uf1b5"
  },
  "steam": {
    "unicode": "\uf1b6"
  },
  "steam-square": {
    "unicode": "\uf1b7"
  },
  "recycle": {
    "unicode": "\uf1b8"
  },
  "car": {
    "unicode": "\uf1b9"
  },
  "taxi": {
    "unicode": "\uf1ba"
  },
  "tree": {
    "unicode": "\uf1bb"
  },
  "spotify": {
    "unicode": "\uf1bc"
  },
  "deviantart": {
    "unicode": "\uf1bd"
  },
  "soundcloud": {
    "unicode": "\uf1be"
  },
  "database": {
    "unicode": "\uf1c0"
  },
  "file-pdf-o": {
    "unicode": "\uf1c1"
  },
  "file-word-o": {
    "unicode": "\uf1c2"
  },
  "file-excel-o": {
    "unicode": "\uf1c3"
  },
  "file-powerpoint-o": {
    "unicode": "\uf1c4"
  },
  "file-image-o": {
    "unicode": "\uf1c5"
  },
  "file-archive-o": {
    "unicode": "\uf1c6"
  },
  "file-audio-o": {
    "unicode": "\uf1c7"
  },
  "file-video-o": {
    "unicode": "\uf1c8"
  },
  "file-code-o": {
    "unicode": "\uf1c9"
  },
  "vine": {
    "unicode": "\uf1ca"
  },
  "codepen": {
    "unicode": "\uf1cb"
  },
  "jsfiddle": {
    "unicode": "\uf1cc"
  },
  "life-ring": {
    "unicode": "\uf1cd"
  },
  "circle-o-notch": {
    "unicode": "\uf1ce"
  },
  "rebel": {
    "unicode": "\uf1d0"
  },
  "empire": {
    "unicode": "\uf1d1"
  },
  "git-square": {
    "unicode": "\uf1d2"
  },
  "git": {
    "unicode": "\uf1d3"
  },
  "hacker-news": {
    "unicode": "\uf1d4"
  },
  "tencent-weibo": {
    "unicode": "\uf1d5"
  },
  "qq": {
    "unicode": "\uf1d6"
  },
  "weixin": {
    "unicode": "\uf1d7"
  },
  "paper-plane": {
    "unicode": "\uf1d8"
  },
  "paper-plane-o": {
    "unicode": "\uf1d9"
  },
  "history": {
    "unicode": "\uf1da"
  },
  "circle-thin": {
    "unicode": "\uf1db"
  },
  "header": {
    "unicode": "\uf1dc"
  },
  "paragraph": {
    "unicode": "\uf1dd"
  },
  "sliders": {
    "unicode": "\uf1de"
  },
  "share-alt": {
    "unicode": "\uf1e0"
  },
  "share-alt-square": {
    "unicode": "\uf1e1"
  },
  "bomb": {
    "unicode": "\uf1e2"
  },
  "futbol-o": {
    "unicode": "\uf1e3"
  },
  "tty": {
    "unicode": "\uf1e4"
  },
  "binoculars": {
    "unicode": "\uf1e5"
  },
  "plug": {
    "unicode": "\uf1e6"
  },
  "slideshare": {
    "unicode": "\uf1e7"
  },
  "twitch": {
    "unicode": "\uf1e8"
  },
  "yelp": {
    "unicode": "\uf1e9"
  },
  "newspaper-o": {
    "unicode": "\uf1ea"
  },
  "wifi": {
    "unicode": "\uf1eb"
  },
  "calculator": {
    "unicode": "\uf1ec"
  },
  "paypal": {
    "unicode": "\uf1ed"
  },
  "google-wallet": {
    "unicode": "\uf1ee"
  },
  "cc-visa": {
    "unicode": "\uf1f0"
  },
  "cc-mastercard": {
    "unicode": "\uf1f1"
  },
  "cc-discover": {
    "unicode": "\uf1f2"
  },
  "cc-amex": {
    "unicode": "\uf1f3"
  },
  "cc-paypal": {
    "unicode": "\uf1f4"
  },
  "cc-stripe": {
    "unicode": "\uf1f5"
  },
  "bell-slash": {
    "unicode": "\uf1f6"
  },
  "bell-slash-o": {
    "unicode": "\uf1f7"
  },
  "trash": {
    "unicode": "\uf1f8"
  },
  "copyright": {
    "unicode": "\uf1f9"
  },
  "at": {
    "unicode": "\uf1fa"
  },
  "eyedropper": {
    "unicode": "\uf1fb"
  },
  "paint-brush": {
    "unicode": "\uf1fc"
  },
  "birthday-cake": {
    "unicode": "\uf1fd"
  },
  "area-chart": {
    "unicode": "\uf1fe"
  },
  "pie-chart": {
    "unicode": "\uf200"
  },
  "line-chart": {
    "unicode": "\uf201"
  },
  "lastfm": {
    "unicode": "\uf202"
  },
  "lastfm-square": {
    "unicode": "\uf203"
  },
  "toggle-off": {
    "unicode": "\uf204"
  },
  "toggle-on": {
    "unicode": "\uf205"
  },
  "bicycle": {
    "unicode": "\uf206"
  },
  "bus": {
    "unicode": "\uf207"
  },
  "ioxhost": {
    "unicode": "\uf208"
  },
  "angellist": {
    "unicode": "\uf209"
  },
  "cc": {
    "unicode": "\uf20a"
  },
  "ils": {
    "unicode": "\uf20b"
  },
  "meanpath": {
    "unicode": "\uf20c"
  },
  "buysellads": {
    "unicode": "\uf20d"
  },
  "connectdevelop": {
    "unicode": "\uf20e"
  },
  "dashcube": {
    "unicode": "\uf210"
  },
  "forumbee": {
    "unicode": "\uf211"
  },
  "leanpub": {
    "unicode": "\uf212"
  },
  "sellsy": {
    "unicode": "\uf213"
  },
  "shirtsinbulk": {
    "unicode": "\uf214"
  },
  "simplybuilt": {
    "unicode": "\uf215"
  },
  "skyatlas": {
    "unicode": "\uf216"
  },
  "cart-plus": {
    "unicode": "\uf217"
  },
  "cart-arrow-down": {
    "unicode": "\uf218"
  },
  "diamond": {
    "unicode": "\uf219"
  },
  "ship": {
    "unicode": "\uf21a"
  },
  "user-secret": {
    "unicode": "\uf21b"
  },
  "motorcycle": {
    "unicode": "\uf21c"
  },
  "street-view": {
    "unicode": "\uf21d"
  },
  "heartbeat": {
    "unicode": "\uf21e"
  },
  "venus": {
    "unicode": "\uf221"
  },
  "mars": {
    "unicode": "\uf222"
  },
  "mercury": {
    "unicode": "\uf223"
  },
  "transgender": {
    "unicode": "\uf224"
  },
  "transgender-alt": {
    "unicode": "\uf225"
  },
  "venus-double": {
    "unicode": "\uf226"
  },
  "mars-double": {
    "unicode": "\uf227"
  },
  "venus-mars": {
    "unicode": "\uf228"
  },
  "mars-stroke": {
    "unicode": "\uf229"
  },
  "mars-stroke-v": {
    "unicode": "\uf22a"
  },
  "mars-stroke-h": {
    "unicode": "\uf22b"
  },
  "neuter": {
    "unicode": "\uf22c"
  },
  "genderless": {
    "unicode": "\uf22d"
  },
  "facebook-official": {
    "unicode": "\uf230"
  },
  "pinterest-p": {
    "unicode": "\uf231"
  },
  "whatsapp": {
    "unicode": "\uf232"
  },
  "server": {
    "unicode": "\uf233"
  },
  "user-plus": {
    "unicode": "\uf234"
  },
  "user-times": {
    "unicode": "\uf235"
  },
  "bed": {
    "unicode": "\uf236"
  },
  "viacoin": {
    "unicode": "\uf237"
  },
  "train": {
    "unicode": "\uf238"
  },
  "subway": {
    "unicode": "\uf239"
  },
  "medium": {
    "unicode": "\uf23a"
  },
  "y-combinator": {
    "unicode": "\uf23b"
  },
  "optin-monster": {
    "unicode": "\uf23c"
  },
  "opencart": {
    "unicode": "\uf23d"
  },
  "expeditedssl": {
    "unicode": "\uf23e"
  },
  "battery-full": {
    "unicode": "\uf240"
  },
  "battery-three-quarters": {
    "unicode": "\uf241"
  },
  "battery-half": {
    "unicode": "\uf242"
  },
  "battery-quarter": {
    "unicode": "\uf243"
  },
  "battery-empty": {
    "unicode": "\uf244"
  },
  "mouse-pointer": {
    "unicode": "\uf245"
  },
  "i-cursor": {
    "unicode": "\uf246"
  },
  "object-group": {
    "unicode": "\uf247"
  },
  "object-ungroup": {
    "unicode": "\uf248"
  },
  "sticky-note": {
    "unicode": "\uf249"
  },
  "sticky-note-o": {
    "unicode": "\uf24a"
  },
  "cc-jcb": {
    "unicode": "\uf24b"
  },
  "cc-diners-club": {
    "unicode": "\uf24c"
  },
  "clone": {
    "unicode": "\uf24d"
  },
  "balance-scale": {
    "unicode": "\uf24e"
  },
  "hourglass-o": {
    "unicode": "\uf250"
  },
  "hourglass-start": {
    "unicode": "\uf251"
  },
  "hourglass-half": {
    "unicode": "\uf252"
  },
  "hourglass-end": {
    "unicode": "\uf253"
  },
  "hourglass": {
    "unicode": "\uf254"
  },
  "hand-rock-o": {
    "unicode": "\uf255"
  },
  "hand-paper-o": {
    "unicode": "\uf256"
  },
  "hand-scissors-o": {
    "unicode": "\uf257"
  },
  "hand-lizard-o": {
    "unicode": "\uf258"
  },
  "hand-spock-o": {
    "unicode": "\uf259"
  },
  "hand-pointer-o": {
    "unicode": "\uf25a"
  },
  "hand-peace-o": {
    "unicode": "\uf25b"
  },
  "trademark": {
    "unicode": "\uf25c"
  },
  "registered": {
    "unicode": "\uf25d"
  },
  "creative-commons": {
    "unicode": "\uf25e"
  },
  "gg": {
    "unicode": "\uf260"
  },
  "gg-circle": {
    "unicode": "\uf261"
  },
  "tripadvisor": {
    "unicode": "\uf262"
  },
  "odnoklassniki": {
    "unicode": "\uf263"
  },
  "odnoklassniki-square": {
    "unicode": "\uf264"
  },
  "get-pocket": {
    "unicode": "\uf265"
  },
  "wikipedia-w": {
    "unicode": "\uf266"
  },
  "safari": {
    "unicode": "\uf267"
  },
  "chrome": {
    "unicode": "\uf268"
  },
  "firefox": {
    "unicode": "\uf269"
  },
  "opera": {
    "unicode": "\uf26a"
  },
  "internet-explorer": {
    "unicode": "\uf26b"
  },
  "television": {
    "unicode": "\uf26c"
  },
  "contao": {
    "unicode": "\uf26d"
  },
  "500px": {
    "unicode": "\uf26e"
  },
  "amazon": {
    "unicode": "\uf270"
  },
  "calendar-plus-o": {
    "unicode": "\uf271"
  },
  "calendar-minus-o": {
    "unicode": "\uf272"
  },
  "calendar-times-o": {
    "unicode": "\uf273"
  },
  "calendar-check-o": {
    "unicode": "\uf274"
  },
  "industry": {
    "unicode": "\uf275"
  },
  "map-pin": {
    "unicode": "\uf276"
  },
  "map-signs": {
    "unicode": "\uf277"
  },
  "map-o": {
    "unicode": "\uf278"
  },
  "map": {
    "unicode": "\uf279"
  },
  "commenting": {
    "unicode": "\uf27a"
  },
  "commenting-o": {
    "unicode": "\uf27b"
  },
  "houzz": {
    "unicode": "\uf27c"
  },
  "vimeo": {
    "unicode": "\uf27d"
  },
  "black-tie": {
    "unicode": "\uf27e"
  },
  "fonticons": {
    "unicode": "\uf280"
  },
  "reddit-alien": {
    "unicode": "\uf281"
  },
  "edge": {
    "unicode": "\uf282"
  },
  "credit-card-alt": {
    "unicode": "\uf283"
  },
  "codiepie": {
    "unicode": "\uf284"
  },
  "modx": {
    "unicode": "\uf285"
  },
  "fort-awesome": {
    "unicode": "\uf286"
  },
  "usb": {
    "unicode": "\uf287"
  },
  "product-hunt": {
    "unicode": "\uf288"
  },
  "mixcloud": {
    "unicode": "\uf289"
  },
  "scribd": {
    "unicode": "\uf28a"
  },
  "pause-circle": {
    "unicode": "\uf28b"
  },
  "pause-circle-o": {
    "unicode": "\uf28c"
  },
  "stop-circle": {
    "unicode": "\uf28d"
  },
  "stop-circle-o": {
    "unicode": "\uf28e"
  },
  "shopping-bag": {
    "unicode": "\uf290"
  },
  "shopping-basket": {
    "unicode": "\uf291"
  },
  "hashtag": {
    "unicode": "\uf292"
  },
  "bluetooth": {
    "unicode": "\uf293"
  },
  "bluetooth-b": {
    "unicode": "\uf294"
  },
  "percent": {
    "unicode": "\uf295"
  },
  "gitlab": {
    "unicode": "\uf296"
  },
  "wpbeginner": {
    "unicode": "\uf297"
  },
  "wpforms": {
    "unicode": "\uf298"
  },
  "envira": {
    "unicode": "\uf299"
  },
  "universal-access": {
    "unicode": "\uf29a"
  },
  "wheelchair-alt": {
    "unicode": "\uf29b"
  },
  "question-circle-o": {
    "unicode": "\uf29c"
  },
  "blind": {
    "unicode": "\uf29d"
  },
  "audio-description": {
    "unicode": "\uf29e"
  },
  "volume-control-phone": {
    "unicode": "\uf2a0"
  },
  "braille": {
    "unicode": "\uf2a1"
  },
  "assistive-listening-systems": {
    "unicode": "\uf2a2"
  },
  "american-sign-language-interpreting": {
    "unicode": "\uf2a3"
  },
  "deaf": {
    "unicode": "\uf2a4"
  },
  "glide": {
    "unicode": "\uf2a5"
  },
  "glide-g": {
    "unicode": "\uf2a6"
  },
  "sign-language": {
    "unicode": "\uf2a7"
  },
  "low-vision": {
    "unicode": "\uf2a8"
  },
  "viadeo": {
    "unicode": "\uf2a9"
  },
  "viadeo-square": {
    "unicode": "\uf2aa"
  },
  "snapchat": {
    "unicode": "\uf2ab"
  },
  "snapchat-ghost": {
    "unicode": "\uf2ac"
  },
  "snapchat-square": {
    "unicode": "\uf2ad"
  }
}